import { create } from "zustand";
import { verifyRequest } from "./authService";

type AdminRole = "admin" | "billing_viewer" | "san_admin" | "san_retailer_viewer";

type AuthStore = {
  isVerified: boolean;
  adminRole?: AdminRole;
  verifyLogin: () => Promise<boolean>;
  setAdminRole: (role: AdminRole) => void;
  isSanRole: () => boolean;
  isSanAdminRole: () => boolean;
};

export const useAuthStore = create<AuthStore>((set, get) => ({
  isVerified: false,
  adminRole: undefined,
  verifyLogin: async () => {
    try {
      const response = await verifyRequest();
      set({ isVerified: true, adminRole: response.role });
      return true;
    } catch {
      set({ isVerified: false, adminRole: undefined });
      return false;
    }
  },
  setAdminRole: (role: AdminRole) => {
    set({ adminRole: role });
  },
  isSanRole: () => {
    return isSanRole(get().adminRole);
  },
  isSanAdminRole: () => {
    const adminRole = get().adminRole;
    return isSanAdminRole(adminRole);
  },
}));

/** SAN ロールか（san_admin / san_retailer_viewer） */
export const isSanRole = (adminRole?: AdminRole): boolean => {
  return adminRole === "san_admin" || adminRole === "san_retailer_viewer";
};

/** SAN ロールか（React コンポーネント・フック向け） */
export function useIsSanRole(): boolean {
  return useAuthStore((state) => state.isSanRole());
}

/** 本人確認情報を扱うロールか */
export const shouldShowIdentificationFields = (adminRole?: AdminRole): boolean => {
  return isSanRole(adminRole);
};

/** 本人確認情報を扱うロールか（React コンポーネント・フック向け） */
export function useShouldShowIdentificationFields(): boolean {
  return useAuthStore((state) => shouldShowIdentificationFields(state.adminRole));
}

export const isSanAdminRole = (adminRole?: AdminRole): boolean => {
  return adminRole === "san_admin";
};
